// extracted by mini-css-extract-plugin
export default {"fireworksIcon":"AuditingSuccess_fireworksIcon__uRqUX","content":"AuditingSuccess_content__uJNjC"};